import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
    className?: string;
    iconOnly?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = "", iconOnly = false }) => {
    return (
        <Link to="/dashboard" className={`flex items-center gap-2 ${className}`}>
            <img 
                src="/logo-final.svg" 
                alt="igleads.co icon" 
                className="h-8 md:h-10 w-auto shrink-0"
            />
            {!iconOnly && (
                <div className="font-bold text-[#401857] text-sm sm:text-base md:text-lg lg:text-xl leading-tight">
                    igleads.co
                </div>
            )}
        </Link>
    );
};

export default Logo;
